import { ClassQnpMRequestModel, ClassRequestModel, CommonResponse, CreatePaperModelReq, SubjectClassReqModel } from "@boi/shared-models";
import { CommonAxiosService } from "../common-axios-service";
import { AxiosRequestConfig } from "axios";

export class ModelPaperCreationService extends CommonAxiosService {

    private getURLwithMainEndPoint(childUrl: string) {
        return '/model-paper/' + childUrl;
    }

    async createModelPaper(createPaperModelReq: CreatePaperModelReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createModelPaper'), createPaperModelReq, config);
    }


    async getModelPaperDataBySubject(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getModelPaperDataBySubject'), req, config)
    }

    async getAllModelPaperData(req: ClassRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllModelPaperData'), req, config)
    }
    
    async getModelPaperData(req: ClassQnpMRequestModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getModelPaperData'), req, config)
    }
}